import { render, staticRenderFns } from "./form2TableCell.vue?vue&type=template&id=192fa8fd&"
import script from "./form2TableCell.vue?vue&type=script&lang=js&"
export * from "./form2TableCell.vue?vue&type=script&lang=js&"
import style0 from "./form2TableCell.vue?vue&type=style&index=0&id=192fa8fd&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports